import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.233 9.038q7.245-2.955 9.662-3.913c4.596-1.8 5.562-2.112 6.183-2.125.232-.005.459.059.65.182.13.11.213.263.234.427q.058.303.027.61c-.248 2.461-1.325 8.434-1.877 11.181-.234 1.166-.69 1.555-1.132 1.594-.966.078-1.697-.596-2.622-1.166-1.463-.894-2.278-1.451-3.7-2.333-1.642-1.01-.58-1.567.36-2.474.248-.234 4.486-3.862 4.568-4.185a.29.29 0 0 0-.082-.273.4.4 0 0 0-.346-.025c-.151.025-2.47 1.477-6.984 4.34-.663.428-1.256.635-1.794.622-.594-.013-1.726-.31-2.582-.57-1.035-.311-1.863-.48-1.794-1.024.041-.285.456-.57 1.229-.868",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }